module.exports = __webpack_public_path__ + "static/media/wpl1.png.f8c73bba.jpg";